"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var notInitialisedErrorMessage = 'ctvFramework not initialised, call initialise() first';
var alreadyInitialisedErrorMessage = 'ctvFramework already initialised or initialising';
var Core = (function () {
    function Core() {
    }
    Core.registerDeviceFactory = function (deviceFactory) {
        this.deviceFactory = deviceFactory;
    };
    Core.initialise = function (addons) {
        var _this = this;
        if (addons === void 0) { addons = []; }
        if (this.isInitialised || this.isInitialising) {
            throw new Error(alreadyInitialisedErrorMessage);
        }
        if (!this.deviceFactory) {
            throw new Error('No factory provided before attempt to initialise()');
        }
        this.isInitialising = true;
        return this.deviceFactory.initialise().then(function () {
            _this.isInitialised = true;
            _this.isInitialising = false;
            var player = _this.getDevice().player;
            player.setAddons(addons);
        });
    };
    Core.getDeviceFactory = function () {
        if (!this.isInitialised) {
            throw new Error(notInitialisedErrorMessage);
        }
        return this.deviceFactory;
    };
    Core.getDevice = function () {
        if (!this.isInitialised) {
            throw new Error(notInitialisedErrorMessage);
        }
        return this.deviceFactory.getInstance();
    };
    Core.isInitialised = false;
    Core.isInitialising = false;
    return Core;
}());
exports.Core = Core;
